import styled from 'styled-components';
import ReactSlider from 'react-slider';

export const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 5px;
`;

export const StyledThumb = styled.div`
  height: 21px;
  width: 21px;
  background-color: ${props => (props.disabled ? 'gray' : '#e78850')};
  color: #e78850;
  border-radius: 50%;
  cursor: grab;
  position: absolute;
  top: -8px;
`;

const getTrackColor = ({ index, nThumbs, disabled }) => {
  const lightColor = disabled ? 'lightgray' : '#C2E7FF';
  const darkColor = disabled ? 'gray' : '#e78850';
  if (nThumbs === 1) {
    return index === 0 ? darkColor : lightColor;
  }
  if (index === 0 || index === 2) {
    return lightColor;
  }
  return darkColor;
};

export const StyledTrack = styled.div`
  top: 0;
  bottom: 0;
  background: ${props => getTrackColor(props)};
  border-radius: 999px;
`;

const Thumb = disabled => (props, state) => <StyledThumb {...props} disabled={disabled}></StyledThumb>;
const Track = disabled => (props, state) =>
  <StyledTrack {...props} disabled={disabled} nThumbs={state.value.length || 1} index={state.index} />;

const Slider = ({ value, changeValue, max, disabled, step = 1, minDistance }) => {
  return (
    <StyledSlider
      value={value}
      onChange={(value, index) => changeValue(value)}
      renderTrack={Track(disabled)}
      renderThumb={Thumb(disabled)}
      max={max}
      step={step}
      disabled={disabled}
      minDistance={minDistance}
      pearling
    />
  );
};

export default Slider;
